import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Divider, Grid, Dialog, DialogContent,
DialogContentText, DialogTitle, Slide, Card, CardContent } from '@material-ui/core';
import { } from '@material-ui/icons';
import  AddIcon  from '@material-ui/icons/Add';
import  DeleteIcon  from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        },
    paper: {
        padding: theme.spacing.unit * 2,
        position: 'relative',
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto',
        width: '75%'
        },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center'
        },
    fab: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
        },
    fab2: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
        },
})
class manageSections extends Component{
    constructor(props){
        super(props)
        this.state = {
            open: false,
            openDelete: false,
            loading: true,
            subject: {
                data: {
                    Content: {
                        Sections: []
                    } 
                }
            }
        }
    }

    async componentDidMount() {
        const obj = await this.fetchData()
        this.setState({
            ...this.state,
            subject: obj
        })
        console.log(this.state)
    }

    async fetchData(){
        const ref = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(this.props.match.params.year).collection('Abilities').doc(this.props.match.params.ability)
        const snapshot = await ref.get()
        return snapshot.data()
    }

    addNewSection = (name) => {
        try { 
            const obj = {
                Name: name,
                HWK: [],
                Tests: []
            };
            var sampleArr = this.state.subject.data.Content.Sections
            sampleArr.push(obj)
            console.log(obj)
            const ref = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(this.props.match.params.year).collection('Abilities').doc(this.props.match.params.ability)
            ref.update({
                'data.Content.Sections' : sampleArr
            }).then(success => {
                console.log('Subject was updated', success),
                this.setState({open: false})
                this.componentDidMount()
            })
        } catch (e) {
            console.error(e)
        }
    }

    handleChange = (name) => event => { 
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
        console.log(event.target.value)
    }

    handleOpen = (name) => { 
        this.setState({
            ...this.state,
            [name]: true
        })
    }

    handleClose = (name) => {
        this.setState({
            [name]: false
        })
    }

    deleteSection = (name) => {
        let index = this.state.subject.data.Content.Sections.indexOf(name)
        const arr = this.state.subject.data.Content.Sections.splice(index, 1)
        var sample = this.state.subject.data.Content.Sections
        console.log(index)
        sample.splice(index, 1)
        console.log(sample)
        this.setState({
            ...this.state,
            Content : { 
                Sections : (sample)
            }
        })
        console.log(this.state)
        const ref = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(this.props.match.params.year).collection('Abilities').doc(this.props.match.params.ability)
            ref.update({
                'data.Content.Sections' : (sample)
            }).then(success => {
                console.log('Section was Deleted', success),
                this.setState({openDelete: false})
                this.componentDidMount()
            })
    }

    keyPressed = (e) => { 
        if (e.key == 'Enter') {
            this.addNewSection(this.state.sectionName)
        }
    }

    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Paper className={classes.paper} elevation={1}>
                    <Typography variant='headline'>
                        Manage sections for 
                    </Typography>
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level)}}> 
                        {this.props.match.params.level} 
                    </Button>
                     - 
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject)}}> 
                        {this.props.match.params.subject} 
                    </Button>
                     - 
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject + '/' + this.props.match.params.year)}}> 
                        { 'Year ' + this.props.match.params.year} 
                    </Button>
                     - 
                    <Button  color='secondary' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject + '/' + this.props.match.params.year + '/' + this.props.match.params.ability)}}> 
                        {this.props.match.params.ability} 
                    </Button>
                    <Divider/>
                    <br/>
                    {this.state.subject.data.Content.Sections.length > 0 ? (
                        <Grid container
                            spacing={40}
                            direction='row'
                            justify='center'
                            alignContent='center'
                            alignItems='center'
                            margin='auto'
                        >
                            {this.state.subject.data.Content.Sections.map(section => {
                                return (
                                    
                                    <Grid item xs={5}>
                                    <Paper className={classes.container}>
                                    
                                        <Typography variant='title'>
                                            {section.Name}
                                        </Typography>
                                        <Divider/>
                                        <br/>
                                        <div style={{margin: 10}}>
                                            {section.HWK.map(hwk => {
                                                return (
                                                    <Typography >
                                                        {hwk}
                                                    </Typography> 
                                                )
                                            })}
                                            <Button variant='' mini color='primary' style={{ display: 'flex', marginLeft: 'auto'}} onClick={() => this.deleteSection(section)}>
                                                <DeleteIcon/>
                                            </Button>
                                        </div>
                                        
                                        </Paper>
                                    </Grid>
                                  
                                )
                            })}
                            
                        </Grid>
                       
                    )
                    :
                    (
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                        <br/>
                        {this.state.loading ? 
                            <Grid item xs={12}>
                                    <div style={{width: '100%', alignItems: 'center'}}>
                                        <CircularProgress className={classes.progress} color="inherit" />
                                    </div> 
                                    {setTimeout(() => {this.setState({loading: false})}, 2000)}
                            </Grid>  
                        :
                            <Grid item xs={12}>
                                <Typography variant='subheading' style={{marginTop: 20}}>
                                    You have no sections for this year group
                                </Typography>
                            </Grid> 
                        }
                        </Grid>
                    )}
                    <Button variant='fab' mini color='primary'  className={classes.fab} onClick={() => this.handleOpen('open')}>
                        <AddIcon/>
                    </Button>
                     <Dialog
                        open={this.state.open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose('open')}
                        aria-labelledby='form-dialog-title'
                    >
                        <DialogTitle id='form=dialog-title'>Create new Section</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                What is the name of the new Section
                            </DialogContentText>
                            <form className={classes.container}>
                                <TextField
                                    id='sectionName'
                                    className={classes.TextField}
                                    value={this.state.newSubject}
                                    placeholder='Enter a name here'
                                    defaultValue='Default'
                                    onChange={this.handleChange('sectionName')}
                                    onKeyPress={this.keyPressed}
                                >
                                </TextField>
                                <br/>
                                <br/>
                                <br/>
                                <Button variant='raised' color='inherit'  align='center' onClick={() => this.addNewSection(this.state.sectionName)}>
                                    Add Section
                                </Button>
                            </form>
                        </DialogContent>
                    </Dialog>
                </Paper>
            </div>
        )
    }
}
export default withStyles(styles)(manageSections);


// WEBPACK FOOTER //
// ./src/admin/manageSections.jsx